(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["manufacturing"] && !Shopify.designMode) return;
  try {
    (function() {
  const container = document.getElementById('manufacturing-story-video-{{ ai_gen_id }}');
  if (!container) return;

  const videos = container.querySelectorAll('.manufacturing-story-video-video-player-{{ ai_gen_id }}');
  const cards = container.querySelectorAll('.manufacturing-story-video-card-{{ ai_gen_id }}');
  const processBlock = container.querySelector('.manufacturing-process-block-{{ ai_gen_id }}');
  const lastCard = cards[cards.length - 1];

  if (!videos.length || !cards.length || !processBlock || !lastCard) return;

  // ---- Video switching (your existing logic) ----
  function switchVideo(targetIndex) {
    videos.forEach(video => {
      const videoIndex = video.getAttribute('data-video-index');
      if (videoIndex === targetIndex) {
        if (!video.classList.contains('active')) {
          video.classList.add('active');
          video.play().catch(e => console.error("Autoplay failed", e));
        }
      } else {
        if (video.classList.contains('active')) {
          video.classList.remove('active');
          video.pause();
        }
      }
    });
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = entry.target.dataset.cardIndex;
        switchVideo(index);
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  });

  cards.forEach(card => observer.observe(card));

  // ---- NEW: release process block after last card ----
  const releaseObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Last card is visible → unstick the process block
        processBlock.style.position = 'relative';
        processBlock.style.top = 'auto';
      } else {
        // Before last card → keep sticky
        processBlock.style.position = 'sticky';
        processBlock.style.top = '150px';
      }
    });
  }, {
    root: null,
    threshold: 0.6
  });

  releaseObserver.observe(lastCard);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-page-desblock"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('[data-accordion]');
  
  accordions.forEach(accordion => {
    const headers = accordion.querySelectorAll('.product-page-desblock-header');

    headers.forEach(header => {
      header.addEventListener('click', () => toggle(header));
      header.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle(header);
        }
      });
    });

    function toggle(header) {
      const content = header.nextElementSibling;
      const isExpanded = header.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        // Close clicked section
        header.setAttribute('aria-expanded', 'false');
        content.classList.remove('open');
        content.classList.add('closed');
      } else {
        // Open clicked section (without closing others)
        header.setAttribute('aria-expanded', 'true');
        content.classList.remove('closed');
        content.classList.add('open');
      }
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
